@if (type && message.length > 0) {
  <div class="__message _type-{{type}}">{{ message | translate }}</div>
}
